<div
    class="tw-bg-white tw-shadow-lg tw-rounded-[32px] tw-py-6 tw-px-8 sm:tw-px-10 tw-w-full tw-max-w-full tw-relative"
>
    <button
        class="tw-absolute tw-top-4 tw-right-4 tw-text-gray-500 hover:tw-text-gray-700"
        (click)="closeDialog()"
    >
        <mat-icon>close</mat-icon>
    </button>

    <!-- Initial Section -->
    <div
        *ngIf="currentSection === 1"
        class="tw-flex tw-flex-col tw-items-center tw-text-center"
    >
        <img
            class="tw-w-[80px] sm:tw-w-[100px] tw-h-auto"
            src="../../../../../../assets/images/New-Miti/Hello.png"
            alt="Hello"
        />
        <div
            class="tw-font-bold tw-text-[24px] sm:tw-text-[28px] tw-text-[#003A70] tw-mt-4"
        >
            {{ "GRANTS.FIRST_STEP_QUESTION" | translate }}
        </div>
        <div
            class="tw-font-medium tw-text-[18px] sm:tw-text-[20px] tw-text-black tw-mt-2"
        >
            {{ "GRANTS.FIRST_STEP_DESCRIPTION" | translate }}
        </div>
        <button
            (click)="openStepper()"
            class="tw-font-medium tw-text-[16px] sm:tw-text-[18px] tw-text-white tw-bg-[#003A70] tw-rounded-[87px] tw-py-3 sm:tw-py-4 tw-px-8 sm:tw-px-10 tw-mt-6"
        >
            {{ "GRANTS.LETS_GO" | translate }}
        </button>
    </div>

    <!-- Custom Stepper Section -->
    <form [formGroup]="searchForm">
        <div *ngIf="currentSection === 2" class="tw-mt-8">
            <div
                class="tw-flex tw-items-center tw-justify-between tw-gap-0 sm:tw-gap-12 tw-mb-6 tw-max-w-[440px] tw-mx-auto"
            >
                <mat-icon
                    *ngIf="currentStep > 1"
                    (click)="prevStep()"
                    class="tw-cursor-pointer tw-absolute tw-top-[15px] md:tw-top-auto tw-left-5"
                >
                    arrow_back
                </mat-icon>

                <div
                    *ngFor="let step of [1, 2, 3]; let i = index"
                    class="tw-relative tw-flex tw-items-center"
                >
                    <div
                        class="tw-w-[20px] tw-h-[20px] tw-text-[12px] sm:tw-text-[16px] md:tw-w-8 md:tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-font-bold tw-border tw-transition-all"
                        [ngClass]="{
                            'tw-bg-[#003A70] tw-text-white tw-border-[#003A70]':
                                currentStep === step,
                            'tw-bg-gray-200 tw-text-gray-600 tw-border-gray-400':
                                currentStep !== step
                        }"
                    >
                        {{ step }}
                    </div>
                    <div
                        class="tw-ml-2 tw-text-[12px] tw-font-light md:tw-text-sm md:tw-font-medium tw-text-gray-700"
                    >
                        <ng-container [ngSwitch]="step">
                            <span *ngSwitchCase="1">{{
                                "GRANTS.OPERATIONS" | translate
                            }}</span>
                            <span *ngSwitchCase="2">{{
                                "GRANTS.INDUSTRY" | translate
                            }}</span>
                            <span *ngSwitchCase="3">{{
                                "GRANTS.FUNDING" | translate
                            }}</span>
                        </ng-container>
                    </div>
                    <div
                        *ngIf="i < 2"
                        class="tw-absolute tw-top-1/2 tw-left-full tw-h-[3px] tw-w-[20px] sm:tw-w-[50px] tw-transition-all tw-ml-2"
                        [ngClass]="{
                            'tw-bg-[#003A70]': currentStep > step,
                            'tw-bg-gray-300': currentStep <= step
                        }"
                    ></div>
                </div>
            </div>

            <!-- Step 1: Business Operation Years -->
            <div *ngIf="currentStep === 1">
                <p
                    class="tw-text-[18px] sm:tw-text-[26px] tw-font-bold tw-text-center tw-text-[#003A70]"
                >
                    {{ "GRANTS.SECOND_STEP_QUESTION" | translate }}
                </p>
                <div class="tw-flex tw-justify-center tw-py-6">
                    <div class="tw-w-[100%] md:tw-w-auto md:tw-min-w-[60%]">
                        <div
                            *ngFor="let option of filters[0].subFilters"
                            class="tw-flex tw-items-center tw-space-x-2 tw-mb-4"
                        >
                            <input
                                type="radio"
                                name="operationDuration"
                                [value]="option.filterBy"
                                id="filter-{{ option.filterBy }}"
                                formControlName="operationDuration"
                            />
                            <label
                                for="filter-{{ option.filterBy }}"
                                class="tw-text-[16px] tw-font-medium"
                                ><span *ngIf="selectedLanguage === 'en'">{{
                                    option.label
                                }}</span>
                                <span *ngIf="selectedLanguage === 'bm'">{{
                                    option.labelBM
                                }}</span></label
                            >
                        </div>
                    </div>
                </div>
                <div
                    class="tw-flex-col tw-flex tw-justify-center tw-items-center"
                >
                    <button
                        (click)="nextStep()"
                        class="tw-bg-[#003A70] tw-text-white tw-font-medium tw-text-[18px] tw-rounded-[88px] tw-py-[12px] tw-px-[40px] tw-w-fit"
                    >
                        {{ "NEXT" | translate }}
                    </button>
                </div>
            </div>

            <!-- Step 2: Industry -->
            <div *ngIf="currentStep === 2">
                <p
                    class="tw-text-[18px] sm:tw-text-[26px] tw-font-bold tw-text-center tw-text-[#003A70]"
                >
                    {{ "GRANTS.THIRD_STEP_QUESTION" | translate }}
                </p>
                <div
                    class="tw-h-[50vh] tw-overflow-y-auto md:tw-h-full md:tw-overflow-hidden tw-flex tw-justify-center tw-py-6"
                >
                    <div class="tw-w-[100%]">
                        <div class="tw-grid tw-grid-cols-2 tw-gap-4">
                            <div
                                *ngFor="let option of filters[2].subFilters"
                                class="tw-flex tw-items-center tw-space-x-2"
                            >
                                <input
                                    type="checkbox"
                                    [value]="option.filterBy"
                                    id="industry-{{ option.filterBy }}"
                                    (change)="onIndustryChange(option.filterBy)"
                                    [checked]="
                                        searchForm
                                            .get('industry')
                                            ?.value?.includes(option.filterBy)
                                    "
                                />
                                <label
                                    for="industry-{{ option.filterBy }}"
                                    class="tw-text-[16px] tw-font-medium"
                                    ><span *ngIf="selectedLanguage === 'en'">{{
                                        option.label
                                    }}</span>
                                    <span *ngIf="selectedLanguage === 'bm'">{{
                                        option.labelBM
                                    }}</span></label
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="tw-mt-4 tw-flex flex-col tw-justify-center tw-flex-col tw-items-center"
                >
                    <button
                        (click)="nextStep()"
                        class="tw-bg-[#003A70] tw-text-white tw-font-medium tw-text-[18px] tw-rounded-[88px] tw-py-[12px] tw-px-[40px] tw-w-fit"
                    >
                        {{ "NEXT" | translate }}
                    </button>
                </div>
            </div>

            <!-- Step 3: Funding Amount -->
            <div *ngIf="currentStep === 3">
                <p
                    class="tw-text-[18px] sm:tw-text-[26px] tw-font-bold tw-text-center tw-text-[#003A70]"
                >
                    {{ "GRANTS.FOURTH_STEP_QUESTION" | translate }}
                </p>
                <div class="tw-flex tw-justify-center tw-py-6">
                    <div class="tw-w-[100%]">
                        <div class="tw-grid tw-gap-4 tw-justify-center">
                            <div
                                *ngFor="let option of filters[3].subFilters"
                                class="tw-flex tw-items-center tw-space-x-2"
                            >
                                <input
                                    type="radio"
                                    name="fundingAmount"
                                    [value]="option.filterBy"
                                    id="funding-{{ option.filterBy }}"
                                    formControlName="fundingAmount"
                                />
                                <label
                                    for="funding-{{ option.filterBy }}"
                                    class="tw-text-[16px] tw-font-medium"
                                    ><span *ngIf="selectedLanguage === 'en'">{{
                                        option.label
                                    }}</span>
                                    <span *ngIf="selectedLanguage === 'bm'">{{
                                        option.labelBM
                                    }}</span></label
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tw-mt-4 tw-flex tw-justify-center">
                    <button
                        (click)="submitForm()"
                        class="tw-bg-[#003A70] tw-text-white tw-font-medium tw-text-[18px] tw-rounded-[88px] tw-py-[12px] tw-px-[40px] tw-w-fit"
                    >
                        {{ "NEXT" | translate }}
                    </button>
                </div>
            </div>
        </div>
        <p class="tw-text-red-500 tw-text-center !tw-my-2" *ngIf="err">
            {{ "GRANTS.ERROR" | translate }}
        </p>
    </form>
</div>
